import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column is-narrow is-flex is-align-items-flex-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localRows, (row, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "columns is-mobile",
        key: idx
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_field, {
            label: (!_ctx.hideHeader && idx === 0) ? _ctx.$t('integrations.key') : ''
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_input, {
                modelValue: row.key,
                "onUpdate:modelValue": ($event: any) => ((row.key) = $event),
                placeholder: _ctx.$t('integrations.paramKeyPlaceholder'),
                onInput: _ctx.emitChange,
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onInput", "disabled"])
            ]),
            _: 2
          }, 1032, ["label"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_b_field, {
            label: (!_ctx.hideHeader && idx === 0) ? _ctx.$t('integrations.value') : ''
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_input, {
                modelValue: row.value,
                "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                placeholder: _ctx.$t('integrations.paramValuePlaceholder'),
                onInput: _ctx.emitChange,
                disabled: _ctx.readOnly
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onInput", "disabled"])
            ]),
            _: 2
          }, 1032, ["label"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.readOnly)
            ? (_openBlock(), _createBlock(_component_b_button, {
                key: 0,
                type: "is-danger",
                onClick: ($event: any) => (_ctx.removeRow(idx)),
                "icon-left": "delete"
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_b_button, {
                key: 1,
                type: "is-danger",
                "icon-left": "delete",
                disabled: "",
                style: {"visibility":"hidden"}
              }))
        ])
      ]))
    }), 128)),
    (!_ctx.readOnly)
      ? (_openBlock(), _createBlock(_component_b_button, {
          key: 0,
          type: "is-primary",
          "icon-left": "plus",
          onClick: _ctx.addRow
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('integrations.addRow')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}